import React from 'react';
import '../../css/Page.scss';
import { History, HistoryEvent } from '../../router/History';

type PageProps = {
	content:any,
	data:any,
	path?:string,
}

export default class Page<Props = {}, States = {}> extends React.Component<Props & PageProps, States & {}> {
	container: HTMLDivElement;
	history = new History();
	getBounds() {
		return this.container.getBoundingClientRect();
	}

	componentDidMount()
	{
		this.history.on(HistoryEvent.CHANGE, this.deeplinkChanged);
	}

	componentDidUpdate()
	{
	}

	componentWillUnmount()
	{
		this.history.off(HistoryEvent.CHANGE, this.deeplinkChanged);
		this.history.destroy();
	}

	private deeplinkChanged = (e) =>
	{
	}

	show()
	{
		this.container?.scrollIntoView();
	}

	wrap(content = null, className = null)
	{
		let classes = ['page'];
		if(this.props.data['name']) classes.push(this.props.data['name']);
		if (className) classes.push(className);
		return (<div ref={r => this.container = r} data-path={this.props.path} className={classes.join(' ')}>
			{content}
			{this.props.children}
		</div>);
	}

	render() {
		return this.wrap();
	}
}	

